<template>
  <v-flex sm10 offset-sm1>
    <v-container pt-5 mt-5 fluid>
      <v-flex>
        <v-card class="elevation-0">
          <div primary-title class="primary--text pa-2 mb-4 mt-3">
            <h3 class="display-1 mb-0 ml-3">{{ 'validate_settings.title' | t }}</h3>
          </div>
          <v-flex class="ml-4 mr-4">
            <user-form :shop="true"/>
          </v-flex>
        </v-card>
      </v-flex>
    </v-container>
  </v-flex>
</template>

<script>
import UserForm from "@/components/UserForm";

export default {
  components: {
    UserForm
  }
};
</script>
